import { SHOW_NAVIGATION } from "./actionTypes";

export const showNavigation = () => {
  return function (dispatch: any) {
    dispatch({ type: SHOW_NAVIGATION, visibility: true });
  };
};
